// extracted by mini-css-extract-plugin
export default {"Row":"AddUserModal_Row__VxwzD","FormBox":"AddUserModal_FormBox__3Klh8","Title":"AddUserModal_Title__YGuAz"};